// extracted by mini-css-extract-plugin
module.exports = {"menuItem":"y_sS g_jk g_fl g_fp g_fz g_dH g_h","menuItemSub":"y_sT g_dP g_fl g_fz","menuMainLink":"y_sV g_jl g_hf","menuLink":"y_sW g_jl g_hf","Link":"y_rC r_rC r_q0 r_rk"};